export const NEGOTIATION_PERIODE_DAYS: number = 60;
